module.exports = "./images/logo-klarna.png";